import Background from 'components/common/Background';
import ErrorNoti from 'components/common/ErrorNoti';
import Header from 'components/common/Header';
import Loading from 'components/common/Loading';
import MasterKidInfo from 'components/service/MasterKidInfo';
import UsersMasterTable from 'components/service/UsersMasterTable';
import UsersTable from 'components/service/UsersTable';
import useCheckAuth from 'hooks/common/useCheckAuth';
import useQueryDebounce from 'hooks/common/useQueryDebounce';
import { boxStyle, buttonStyle, inputStyle } from 'lib/styles/index';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

const ServiceUsersPage = () => {
  const isCheck = useCheckAuth('1');
  const { usersLoading, serviceError } = useSelector(({ service }) => service);
  const [search, setSearch] = useState('');
  const debouncedSearch = useQueryDebounce(search, 200);
  const [seniorPage, setSeniorPage] = useState(1);
  const [juniorPage, setJuniorPage] = useState(1);
  const [watingPage, setWatingPage] = useState(1);

  const onChange = e => {
    setSearch(e.target.value);
    setSeniorPage(1);
    setJuniorPage(1);
    setWatingPage(1);
  };

  return (
    <ServiceUsersPageBlock isCheck={isCheck}>
      <Header service />
      <Background>
        {serviceError ? (
          <ErrorNoti />
        ) : (
          <div className="body">
            <div className="title-l">권한 관리</div>
            <UsersMasterTable />
            <MasterKidInfo />
            <StyledInput
              type="text"
              placeholder="매장명 또는 사원 이름을 입력하세요"
              value={search}
              onChange={onChange}
            />
            {usersLoading.length !== 0 && <LoadingWithMarginTop />}
            <UsersTable
              title="시니어 관리자"
              userType={2}
              search={debouncedSearch}
              currentPage={seniorPage}
              setCurrentPage={setSeniorPage}
              usersLoading={usersLoading}
            />
            <UsersTable
              title="주니어 관리자"
              userType={3}
              search={debouncedSearch}
              currentPage={juniorPage}
              setCurrentPage={setJuniorPage}
              usersLoading={usersLoading}
            />
            <UsersTable
              title="대기 목록"
              userType={0}
              search={debouncedSearch}
              currentPage={watingPage}
              setCurrentPage={setWatingPage}
              usersLoading={usersLoading}
            />
          </div>
        )}
      </Background>
    </ServiceUsersPageBlock>
  );
};

export default ServiceUsersPage;

const ServiceUsersPageBlock = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .body {
    width: 1080px;
    padding: 2rem 0;
    margin: 0 auto;
  }

  .title-l {
    font-size: 1.3rem;
    font-weight: bold;
    letter-spacing: 4px;
  }

  .title {
    font-size: 1.2rem;
    font-weight: bold;
    letter-spacing: 2px;
  }

  .bold {
    font-weight: bold;
  }

  .box {
    ${boxStyle}
  }

  .row {
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    position: relative;
  }

  .cell {
    width: 180px;
    text-align: center;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      margin-right: 4px;
    }
  }

  .small {
    width: 120px;
  }

  .btn {
    ${buttonStyle}
    width: 80px;
    padding: 4px 0;
    font-size: 12px;
  }

  ${props =>
    !props.isCheck &&
    css`
      visibility: hidden;
    `}
`;

const StyledInput = styled.input`
  ${inputStyle}
  width: 50%;
  margin: 0 auto;
  margin-top: 2rem;
  display: block;
  font-size: 18px;
`;

const LoadingWithMarginTop = styled(Loading)`
  margin-top: 3rem;
`;
